import { responseStatus } from "./consts.util";
import { findAndScrollToTheErrorFirstElement } from "./customFunk";

const parseApiErrors = (graphQLErrors, scrollToException ) => {
  let errors = {};

  if (graphQLErrors) {
    graphQLErrors.map(({ message, extensions }) => {
      errors["status"] = extensions.status;
      if ("internal" === extensions.category) {
        if (message.includes(":")) {
          Object.entries(JSON.parse(message)).forEach(([key, value]) => {
            errors[key] = value.trim()
          });
        } else {
          errors["internal"] = message;
        }
      } else if (extensions.violations) {
        extensions.violations.map(
          ({ path, message }) => (errors[path] = errors[path] ? errors[path]: message)
        );

        if (scrollToException) {
          findAndScrollToTheErrorFirstElement(`[name=${extensions.violations?.[0]?.path}]`);
        }

      } else if (403 === extensions.status && "user" === extensions.category) {
        errors["user"] = message;
      }
    });
  }
  return errors;
};

const parseAxiosError = (response) => {
  let errors = {};
  if (!response) {
    return errors;
  }

  if (response.data.status === responseStatus.HTTP_UNAUTHORIZED || response.data.status === responseStatus.HTTP_INTERNAL_SERVER_ERROR) {
    errors["internal"] = response.data.detail;
  } else if (response.data.status === responseStatus.FORBIDDEN) {
    errors["user"] = response.data.detail;
  }
  if (response.data?.violations) {
    response.data?.violations.map(({ message, propertyPath }) => {
      let name = propertyPath.replaceAll("[", "").replaceAll("]", "");
      errors[name] = message;
    });
  }
  return errors;
};

export const parseMultipleGraphQLErrors = (graphQLErrors) => {
  const parsForNotification = graphQLErrors[0].message.split("\n");
  const errorTexts = parsForNotification.map((error) => error.split(": ")[1]).join(", ");

  return errorTexts || parsForNotification;
};

const parseIRI = (IRI) => {
  const regex = /\d+/i;
  return +IRI.match(regex)[0];
};

const parseUuidIRI = (IRI) => {
  return IRI.split("/")[3];
};

export { parseApiErrors, parseIRI, parseUuidIRI, parseAxiosError };
